import {Directive} from '@angular/core';
import {FormControl, NG_VALIDATORS} from '@angular/forms';
import {checkIfValidHostName} from '../util/CommonFunctions';

//ref: https://gist.github.com/pyrocat101/7568655

export function checkIfValidIPV4(ip: string): boolean { //todo remove
  const IPV4_REGEX = new RegExp(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/);
  return IPV4_REGEX.test(ip);
}

export function checkIfValidIPV6(ip: string): boolean {
  const IPV6_REGEX = new RegExp(/^([0-9a-f]|:){1,4}(:([0-9a-f]{0,4})*){1,7}$/i);
  return IPV6_REGEX.test(ip);
}

export function checkIfValidIP(ip: string) {
  if (ip == null || ip.trim() === "") {
    return false;
  }
  if (checkIfValidIPV4(ip)) {
    return true;
  } else if (checkIfValidIPV6(ip)) {
    return true;
  }

  return false;
}

export function validateIpAddress(c: FormControl) {

  let invalidIpAddress: string[] = [];

  let val = c.value.split(",");
  for (let value of val) {
    if (!checkIfValidIP(value.trim())) {
      invalidIpAddress.push(value.trim());
    }
  }

  if (invalidIpAddress.length > 0) {
    return {
      invalidIpAddress: invalidIpAddress,
      ipAddress: c.value
    }
  }

  return null;
}

export function validateHostName(c: FormControl) {
  if (!checkIfValidHostName(c.value)) {
    return {
      invalidHostName: true,
      hostName: c.value
    }
  }
  return null;
}

@Directive({
  selector: '[nameServersValidator][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useValue: [validateIpAddress, validateHostName], multi: true}
  ]
})
export class NameServersValidatorDirective {

  constructor() {
  }

}
